<template>
  <v-container fluid>
    <PageHeading
      text="Маршруты"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-route-new'
          }"
        >
          <v-icon
            class="mr-2"
            small
          >
            mdi-plus
          </v-icon>
          Создать маршрут
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridRoutes ref="grid"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridRoutes from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  components: {
    PageHeading,
    GridRoutes
  },
  metaInfo () {
    return {
      title: 'Маршруты'
    }
  },
  mixins: [gridPageInterface]
}
</script>
